import { computed, makeObservable, observable, runInAction, action } from 'mobx';
import { AgenturStore } from '../agentur.store';
import { ISelectOpt } from 'app/components/common/Select';
import { formatBM } from 'app/utils';
import { AgenturModel } from 'app/models/agentur.model';
import _ from 'lodash';
import { BaseUiStore } from './base.ui.store';
import { AgtFacebookStore, AgtFacebookModel } from '../agt.facebook.store';
import { AgtInstagramStore, AgtInstagramModel } from '../agt.instagram.store';
import { AgtTiktokStore, AgtTiktokModel } from '../agt.tiktok.store';
import { AgtLinkedinStore, AgtLinkedinModel } from '../agt.linkedin.store';

export class InstagramBm {
	bm: number;
	url: string;
	status: number;
	follow: number;
	views: number;
	posts: number;
	aboPr: number;
	ownPosts: number;

	constructor(bm: number, url: string, status: number, follow: number, views: number, posts: number, aboPr: number, ownPosts: number) {
		this.bm = bm;
		this.url = url ? (url.startsWith('http') ? url : `https://www.instagram.com/${url}`) : url;
		this.status = status;
		this.follow = follow;
		this.views = views;
		this.posts = posts;
		this.aboPr = aboPr;
		this.ownPosts = ownPosts;
	}
}

export class FacebookBm {
	bm: number;
	url: string;
	status: number;
	fans: number;
	subs: number;
	posts: number;
	reach: number;
	views: number;
	aboPr: number;
	abo1890: number;
	ownPosts: number;

	constructor(bm: number, url: string, status: number, fans: number, subs: number, posts: number, reach: number, views: number, aboPr: number, abo1890: number, ownPosts: number) {
		this.bm = bm;
		this.url = url ? (url.startsWith('http') ? url : `https://www.facebook.com/${url}`) : url;
		this.status = status;
		this.fans = fans;
		this.subs = subs;
		this.posts = posts;
		this.reach = reach;
		this.views = views;
		this.abo1890 = abo1890;
		this.aboPr = aboPr;
		this.ownPosts = ownPosts;
	}
}

export class TiktokBm {
	bm: number;
	screenName: string;
	status: number;
	follower: number;
	views: number;
	reach: number;
	posts: number;

	constructor(bm: number, screenName: string, status: number, follower: number, views: number, reach: number, posts: number) {
		this.bm = bm;
		this.screenName = screenName;
		this.status = status;
		this.follower = follower;
		this.views = views;
		this.reach = reach;
		this.posts = posts;
	}
}

export class LinkedinBm {
	bm: number;
	url: string;
	status: number;
	follower: number;
	views: number;
	reach: number;
	posts: number;

	constructor(bm: number, url: string, status: number, follower: number, views: number, reach: number, posts: number) {
		this.bm = bm;
		this.url = url ? (url.startsWith('http') ? url : `https://www.linkedin.com/in/${url}`) : url;
		this.status = status;
		this.follower = follower;
		this.views = views;
		this.reach = reach;
		this.posts = posts;
	}
}

export class AgtSocialMediaVM {
	agt: AgenturModel;
	@observable
	fbs: FacebookBm[] = [];
	instas: InstagramBm[] = [];
	tiktoks: TiktokBm[] = [];
	linkedins: LinkedinBm[] = [];

	prevYearBm: number = 0;
	currYearBm: number = 0;
	currYear: number = 0;

	constructor(agt: AgenturModel, fbs: AgtFacebookModel[], instas: AgtInstagramModel[], tiktoks: AgtTiktokModel[] = [], linkedins: AgtLinkedinModel[] = []) {
		makeObservable(this);
		this.agt = agt;
		const bms = [];
		for (const kv of fbs) {
			const j = kv.j;
			const kw = new FacebookBm(kv.bm, j.u, j.s, j.f, j.b, j.p, j.r, j.v, j.a, j.o, j.w);
			bms.push(kv.bm);
			this.fbs.push(kw);
		}
		for (const kv of instas) {
			const j = kv.j;
			const kw = new InstagramBm(kv.bm, j.u, j.s, j.f, j.v, j.p, j.a, j.w);
			bms.push(kv.bm);
			this.instas.push(kw);
		}
		for (const kv of tiktoks) {
			const j = kv.j;
			const tk = new TiktokBm(kv.bm, j.n, j.s, j.f, j.v, j.r, j.p);
			bms.push(kv.bm);
			this.tiktoks.push(tk);
		}
		for (const kv of linkedins) {
			const j = kv.j;
			const li = new LinkedinBm(kv.bm, j.u, j.s, j.f, j.v, j.r, j.p);
			bms.push(kv.bm);
			this.linkedins.push(li);
		}
		if (bms.length > 0) {
			this.currYearBm = _.max(bms)!;
			this.currYear = Math.round(this.currYearBm / 100);
			this.prevYearBm = (this.currYear - 1) * 100 + 12;
		}
	}

	@computed
	get hasMoreThan30kViewsMultiGp26() {
		return this.allViewsYtdMultiGp >= 30000 ? 1 : 0;
	}

	@computed
	get hasMoreThan30kViewsMultiGp26GpCount() {
		return this.hasMoreThan30kViewsMultiGp26 === 1 ? (this.agt.thCount ? this.agt.thCount : 0) : 0;
	}



	@computed
	get prevFb() {
		return this.fbs.find((f) => f.bm === this.prevYearBm);
	}

	@computed
	get prevInsta() {
		return this.instas.find((f) => f.bm === this.prevYearBm);
	}

	@computed
	get currInsta() {
		return this.instas.reduce<InstagramBm | undefined>((max, insta) => (insta.bm > (max?.bm || 0) ? insta : max), undefined);
	}

	@computed
	get currFb() {
		return this.fbs.reduce<FacebookBm | undefined>((max, fb) => (fb.bm > (max?.bm || 0) ? fb : max), undefined);
	}

	@computed
	get ytdFbViews() {
		const total = this.fbs.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100) {
				return acc + f.views;
			}
			return acc;
		}, 0);
		return total === 0 ? null : total;
	}
	@computed
	get ytdInstaViews() {
		const total = this.instas.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100) {
				return acc + f.views;
			}
			return acc;
		}, 0);
		return total === 0 ? null : total;
	}


	@computed
	get ydtTiktokViews() {
		const total = this.tiktoks.reduce((acc, t) => {
			if (t.bm >= this.currYear * 100) {
				return acc + t.views;
			}
			return acc;
		}, 0);
		return total === 0 ? null : total;
	}








	@computed
	get prevFF() {
		return (this.prevFb ? this.prevFb.fans : 0) + (this.prevInsta ? this.prevInsta.follow : 0);
	}

	@computed
	get prevFFGreater250() {
		return this.prevFF >= 250 ? 1 : 0;
	}

	@computed
	get currFF() {
		return (this.currFb ? this.currFb.fans : 0) + (this.currInsta ? this.currInsta.follow : 0);
	}

	@computed
	get currFFGreater250() {
		return this.currFF >= 250 ? 1 : 0;
	}

	@computed
	get gpCount() {
		if (this.currFFGreater250 === 1) {
			return this.agt.thCount ? this.agt.thCount : 0;
		}
		return 0
	}

	@computed
	get fbPostsYtd() {
		return this.fbs.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100 && f.posts) {
				return acc + f.posts;
			}
			return acc;
		}, 0);
	}

	@computed
	get fbOwnPostsYtd() {
		return this.fbs.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100 && f.ownPosts) {
				return acc + f.ownPosts;
			}
			return acc;
		}, 0);
	}

	@computed
	get fbViewsYtd() {
		return this.fbs.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100 && f.views) {
				return acc + f.views;
			}
			return acc;
		}, 0);
	}

	@computed
	get instaPostsYtd() {
		return this.instas.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100 && f.posts) {
				return acc + f.posts;
			}
			return acc;
		}, 0);
	}

	@computed
	get instaViewsYtd() {
		return this.instas.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100 && f.views) {
				return acc + f.views;
			}
			return acc;
		}, 0);
	}

	@computed
	get instaOwnPostsYtd() {
		return this.instas.reduce((acc, f) => {
			if (f.bm >= this.currYear * 100 && f.ownPosts) {
				return acc + f.ownPosts;
			}
			return acc;
		}, 0);
	}

	@computed
	get prevTiktok() {
		return this.tiktoks.find((t) => t.bm === this.prevYearBm);
	}

	@computed
	get currTiktok() {
		return this.tiktoks.reduce<TiktokBm | undefined>((max, tk) => (tk.bm > (max?.bm || 0) ? tk : max), undefined);
	}

	@computed
	get tiktokPostsYtd() {
		return this.tiktoks.reduce((acc, t) => {
			if (t.bm >= this.currYear * 100 && t.posts) {
				return acc + t.posts;
			}
			return acc;
		}, 0);
	}

	@computed
	get tiktokViewsYtd() {
		return this.tiktoks.reduce((acc, t) => {
			if (t.bm >= this.currYear * 100 && t.views) {
				return acc + t.views;
			}
			return acc;
		}, 0);
	}

	@computed
	get tiktokReachYtd() {
		return this.tiktoks.reduce((acc, t) => {
			if (t.bm >= this.currYear * 100 && t.reach) {
				return acc + t.reach;
			}
			return acc;
		}, 0);
	}

	@computed
	get prevLinkedin() {
		return this.linkedins.find((l) => l.bm === this.prevYearBm);
	}

	@computed
	get currLinkedin() {
		return this.linkedins.reduce<LinkedinBm | undefined>((max, li) => (li.bm > (max?.bm || 0) ? li : max), undefined);
	}

	@computed
	get allViewsYtd() {
		return this.ytdFbViews! + this.ytdInstaViews! + this.ydtTiktokViews! + this.ytdLinkedinViews!;
	}
	@computed
	get allViewsYtdMultiGp() {
		return this.ytdFbViews! + this.ytdInstaViews!;
	}

	@computed
	get ytdLinkedinViews() {
		const total = this.linkedins.reduce((acc, l) => {
			if (l.bm >= this.currYear * 100) {
				return acc + l.views;
			}
			return acc;
		}, 0);
		return total === 0 ? null : total;
	}

	@computed
	get linkedinPostsYtd() {
		return this.linkedins.reduce((acc, l) => {
			if (l.bm >= this.currYear * 100 && l.posts) {
				return acc + l.posts;
			}
			return acc;
		}, 0);
	}

	@computed
	get linkedinViewsYtd() {
		return this.linkedins.reduce((acc, l) => {
			if (l.bm >= this.currYear * 100 && l.views) {
				return acc + l.views;
			}
			return acc;
		}, 0);
	}

	@computed
	get linkedinReachYtd() {
		return this.linkedins.reduce((acc, l) => {
			if (l.bm >= this.currYear * 100 && l.reach) {
				return acc + l.reach;
			}
			return acc;
		}, 0);
	}
}

export class AgtSocialMediaUiStore extends BaseUiStore<AgtSocialMediaVM> {
	name = 'AgtSocialMediaUiStore';
	agtFacebookStore: AgtFacebookStore;
	agtInstagramStore: AgtInstagramStore;
	agtTiktokStore: AgtTiktokStore;
	agtLinkedinStore: AgtLinkedinStore;
	agenturStore: AgenturStore;

	constructor(agenturStore: AgenturStore, agtFacebookStore: AgtFacebookStore, agtInstagramStore: AgtInstagramStore, agtTiktokStore: AgtTiktokStore, agtLinkedinStore: AgtLinkedinStore) {
		super();
		makeObservable(this);
		this.agtFacebookStore = agtFacebookStore;
		this.agtInstagramStore = agtInstagramStore;
		this.agtTiktokStore = agtTiktokStore;
		this.agtLinkedinStore = agtLinkedinStore;
		this.agenturStore = agenturStore;
	}
	@observable
	bms: number[] = [];

	@observable
	minBmCurrent?: number;

	@observable
	maxBmCurrent?: number;

	@computed
	get currentYear() {
		const mb = this.maxBm;
		if (mb === undefined) {
			return '';
		}
		return Math.floor(mb / 100);
	}

	@computed
	get maxBm() {
		if (this.maxBmCurrent) return this.maxBmCurrent;
		return _.max(this.bms);
	}

	@computed
	get minBm() {
		if (this.minBmCurrent) return this.minBmCurrent;
		return _.min(this.bms);
	}

	@computed
	get bmOpts(): ISelectOpt[] {
		return this.bms.map((bm) => {
			return {
				value: bm,
				label: formatBM(bm),
			};
		});
	}

	// range selected in the social media berichte (independent of minBmCurrent/maxBmCurrent, which the fitness tracker owns)
	@observable
	rangeMinBm?: number;

	@observable
	rangeMaxBm?: number;

	@computed
	get ytdMaxBm() {
		return _.max(this.bms);
	}

	@computed
	get ytdMinBm() {
		const max = this.ytdMaxBm;
		if (!max) {
			return undefined;
		}
		const yearStart = Math.floor(max / 100) * 100 + 1;
		return _.min(this.bms.filter((bm) => bm >= yearStart));
	}

	@computed
	get selectedMinBm() {
		return this.rangeMinBm ?? this.ytdMinBm;
	}

	@computed
	get selectedMaxBm() {
		return this.rangeMaxBm ?? this.ytdMaxBm;
	}

	@observable
	fbBms: number[] = [];
	@observable
	instaBms: number[] = [];
	@observable
	tiktokBms: number[] = [];
	@observable
	linkedinBms: number[] = [];

	async _baseLoad() {

		// Get all distinct BMs
		const [fbBms, instaBms, tiktokBms, linkedinBms] = await Promise.all([
			this.agtFacebookStore.getDistinctBMs(),
			this.agtInstagramStore.getDistinctBMs(),
			this.agtTiktokStore.getDistinctBMs(),
			this.agtLinkedinStore.getDistinctBMs(),
		]);
		this.fbBms = fbBms
		this.instaBms = instaBms;
		this.tiktokBms = tiktokBms;
		this.linkedinBms = linkedinBms;

		runInAction(() => {
			this.bms = _.uniq([...fbBms, ...instaBms, ...tiktokBms, ...linkedinBms]).sort();
		});


	}

	// loads all monthly rows of the given range and builds VMs from them, so the ytd getters
	// sum over the actual months. does NOT write this.items - that belongs to loadByMaxBmForYear
	// and its consumers (fitness tracker, multi gp).
	async loadByBmRange(minBm: number, maxBm: number): Promise<AgtSocialMediaVM[]> {
		const cacheKey = `AgtSocialMediaUiStore.loadByBmRange${minBm}-${maxBm}`;

		return this.withCache(
			cacheKey,
			async () => {
				await this.load();

				const [fbs, instas, tiktoks, linkedins, agts] = await Promise.all([
					this.agtFacebookStore.loadByBmRange(minBm, maxBm),
					this.agtInstagramStore.loadByBmRange(minBm, maxBm),
					this.agtTiktokStore.loadByBmRange(minBm, maxBm),
					this.agtLinkedinStore.loadByBmRange(minBm, maxBm),
					this.agenturStore.findAll(),
				]);

				const fbsByAgtId = _.groupBy(fbs, 'agtId');
				const instasByAgtId = _.groupBy(instas, 'agtId');
				const tiktoksByAgtId = _.groupBy(tiktoks, 'agtId');
				const linkedinsByAgtId = _.groupBy(linkedins, 'agtId');

				const res: AgtSocialMediaVM[] = [];
				for (const agt of agts) {
					const sm = new AgtSocialMediaVM(agt, fbsByAgtId[agt.agtId] || [], instasByAgtId[agt.agtId] || [], tiktoksByAgtId[agt.agtId] || [], linkedinsByAgtId[agt.agtId] || []);
					res.push(sm);
				}
				return res;
			},
			{
				cacheResult: true,
				measureTime: true,
			},
		);
	}

	async loadYtd(): Promise<AgtSocialMediaVM[]> {
		await this.load();
		if (!this.ytdMinBm || !this.ytdMaxBm) {
			return [];
		}
		return this.loadByBmRange(this.ytdMinBm, this.ytdMaxBm);
	}

	async loadBySelectedRange(): Promise<AgtSocialMediaVM[]> {
		await this.load();
		const minBm = this.selectedMinBm;
		const maxBm = this.selectedMaxBm;
		if (!minBm || !maxBm) {
			return [];
		}
		return this.loadByBmRange(minBm, maxBm);
	}

	async loadByMaxBmForYear(yearBm: number) {
		const cacheKey = `AgtSocialMediaUiStore.loadByBm${this.maxBm}-${this.minBm}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				const maxBmorEndofYear = (bm: number) => {
					if (bm > (yearBm + 1) * 100) return yearBm * 100 + 12;
					return bm
				};

				const maxFbBm = maxBmorEndofYear(_.max(this.fbBms)!);
				const maxInstaBm = maxBmorEndofYear(_.max(this.instaBms)!);
				const maxTiktokBm = this.tiktokBms.length > 0 ? maxBmorEndofYear(_.max(this.tiktokBms)!) : 0;
				const maxLinkedinBm = this.linkedinBms.length > 0 ? maxBmorEndofYear(_.max(this.linkedinBms)!) : 0;

				const [fbs, instas, tiktoks, linkedins, agts] = await Promise.all([
					this.agtFacebookStore.loadByBm(maxFbBm),
					this.agtInstagramStore.loadByBm(maxInstaBm),
					maxTiktokBm > 0 ? this.agtTiktokStore.loadByBm(maxTiktokBm) : Promise.resolve([]),
					maxLinkedinBm > 0 ? this.agtLinkedinStore.loadByBm(maxLinkedinBm) : Promise.resolve([]),
					this.agenturStore.findAll()

				]);

				const res: AgtSocialMediaVM[] = [];
				for (const agt of agts) {
					// deduplication has been moved to etl layer on server
					// (only one account per agency should exist now - the one with most fans across all months)

					// Filter Facebook data for this agency
					let fb = fbs.filter((d) => d.agtId === agt.agtId);

					// Filter Instagram data for this agency
					let insta = instas.filter((d) => d.agtId === agt.agtId);

					// Filter TikTok data for this agency
					let tiktok = tiktoks.filter((d) => d.agtId === agt.agtId);

					// Filter LinkedIn data for this agency
					let linkedin = linkedins.filter((d) => d.agtId === agt.agtId);
					if (linkedin.length > 1) {
						debugger
					}

					const sm = new AgtSocialMediaVM(agt, fb, insta, tiktok, linkedin);
					res.push(sm);
				}

				runInAction(() => {
					this.items = res;
				});

				// Return filtered items for the current BM range
				return this.items;
			},
			{
				cacheResult: true,
				measureTime: true,
			}
		);
	}
}
